import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../Buttons";
import DropDownMenu from "../../DropDownMenu";

import usersService from "../../../../services/userService";

import "./notificationDropdown.scss";

function NotificationDropdown({ notifications }) {
  const { t } = useTranslation();
  return (
    <DropDownMenu customClassName="notification-dropdown">
      <ul>
        <li className="hasBorderBottom notification-dropdown-title">
          <p>{t("yourNotification")}</p>{" "}
          <Button
            label={t("viewAll")}
            customClassName="view-all-notification"
            onClick={() => usersService.goToMonolith("notifications/all/")}
          />
        </li>
        <li className="notification-dropdown-list">
          <ul>
            {notifications?.map((item) => (
              <li key={item?.id} className="notification-dropdown-item">
                <Button
                  onClick={() => usersService.goToMonolith(`notifications/${item?.id}/`)}
                  customClassName="notification-link"
                >
                  <div className="notification-dropdown-item-header">
                    <div className="notification-dropdown-item-title">
                      {item?.notification_title}
                    </div>
                    <div className="notification-dropdown-item-date">
                      {item?.created_at}
                    </div>
                  </div>
                  <div className="notification-dropdown-body">
                    <p className="notification-dropdown-text">
                      {item?.notification_text}
                    </p>
                    {item?.user_image && (
                      <div className="notification-dropdown-img">
                        <img src={item?.user_image} alt="Blue Manor Academy" />
                      </div>
                    )}
                  </div>
                </Button>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </DropDownMenu>
  );
}

export default NotificationDropdown;
